import { render } from "./AppTextbookSettingsModal.vue?vue&type=template&id=87f27976&scoped=true"
import script from "./AppTextbookSettingsModal.vue?vue&type=script&lang=js"
export * from "./AppTextbookSettingsModal.vue?vue&type=script&lang=js"

import "./AppTextbookSettingsModal.vue?vue&type=style&index=0&id=87f27976&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f27976"]])

export default __exports__